<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/carmanage/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="车牌号" prop='vehicleKey'>
          <el-input clearable v-model="searchForm.vehicleKey" placeholder="车牌号" />
        </el-form-item>
        <el-form-item label="司机姓名" prop='driverName'>
          <el-input clearable v-model="searchForm.driverName" placeholder="司机姓名" />
        </el-form-item>
        <el-form-item label="司机手机号" prop='driverMobile'>
          <el-input clearable v-model="searchForm.driverMobile" placeholder="司机手机号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="onTabChange">
        <!-- <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
          :key="index"></el-tab-pane> -->
        <el-tab-pane label="货车" name="0"></el-tab-pane>
        <el-tab-pane label="罐车" name="1"></el-tab-pane>
        <el-tab-pane label="油轮" name="2"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="司机身份证" prop="driverKey"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="司机手机号"
          prop="driverMobile"></el-table-column>
        <el-table-column width="120" label="司机照片">
          <template v-slot="{ row }">
            <!-- 预览使用原图 URL，列表仅约束缩略图尺寸 -->
            <el-image v-if="row.driverPhotoUrl" :src="row.driverPhotoUrl"
              :preview-src-list="[row.driverPhotoUrl]" fit="cover" style="width: 60px; height: 60px" />
            <span v-else>暂无照片</span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text"
                @click="$router.push('/carmanage/detail?vehicleId=' + row.vehicleId)">详情</el-button>
              <el-button type="text" v-if="hasEdit"
                @click=" $router.push('/carmanage/edit?vehicleId=' + row.vehicleId)">编辑</el-button>
              <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.vehicleId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { planType } from '@/utils/dict'

export default {
  name: 'CarManage',
  mixins: [keepAlive],
  data() {
    return {
      activeName: '0',
      planTypeMap: planType,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        vehicleKey: '',
        driverName: '',
        driverMobile: '',
        planType: '1',
        isOiltanker: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onTabChange() {
      console.log('activeName', this.activeName)
      if (this.activeName === '0') {
        this.searchForm.planType = '1'
        this.searchForm.isOiltanker = ''
      } else if (this.activeName === '1') {
        this.searchForm.planType = '2'
        this.searchForm.isOiltanker = '0'
      } else if (this.activeName === '2') {
        this.searchForm.planType = '2'
        this.searchForm.isOiltanker = '1'
      }
      this.onSearch()
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(vehicleId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.carManage.deleteDataWlVehicleInfo, {
          vehicleId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
